// extracted by mini-css-extract-plugin
export default {"thumb":"qrUqZWml","activeThumb":"wutP2Ry_","wrapper":"ZzNX5p4f","wrapperLeft":"SZAWZ7xz","container":"SF7gUx5V","lastThumb":"W21V79YB"};